import React from "react";
import {
    Box,
    Typography,
} from '@mui/material';

/**
 * 申請内容確認画面のヘッダーメッセージコンポーネント
 * - 「内容確認」タイトルと申請確定の案内メッセージを表示する
 */
export const RecordDetailHeaderMessage = () => {
    return (
        <Box sx={{ display: 'flex', mt: 4, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                {/* 画面テーマ */}
                <Typography variant="h2" sx={{}}>
                    内容確認
                </Typography>

                {/* 提示メッセージ */}
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    内容をご確認の上、問題がなければ「申請確定」ボタンをクリックしてください。
                </Typography>
            </Box>
        </Box>
    );
};